<template>
    <b-dropdown aria-role="menu" class="fields" :mobile-modal="false">
        <a class="button is-white" slot="trigger" role="button">
            <span class="icon">
                <Icon name="TableConfig" />
            </span>
            <span>{{ $t('fields') }}</span>
        </a>
        <div class="head">{{ $t('showFields') }}:</div>
        <b-dropdown-item aria-role="menu-item" custom v-for="(field, index) in defaultFields" :key="index">
            <chooseInput type="CHECKBOX" v-model="field._visible" @input="updateFields()" :label="field.label" />
        </b-dropdown-item>
    </b-dropdown>
</template>

<script>
import Icon from './../public/Icon.vue';
export default {
    name: 'fieldsButton',
    props: {
        value: { type: Array },
        fields: { type: Array },
        id: { type: String, required: true },
    },
    components: {
        Icon,
    },
    watch: {
        fields: {
            handler(newValue, oldValue) {
                this.handleFields();
            },
            deep: true,
        },
    },
    data() {
        return {
            defaultFields: [],
        };
    },
    created() {
        this.handleFields();
    },
    methods: {
        getLabel(i18nLabel) {
            return this.$t(i18nLabel) != i18nLabel ? this.$t(i18nLabel) : i18nLabel.replace('projectFields.', '');
        },
        handleFields() {
            if (this.fields && this.fields.length > 0) {
                if (!this.value || this.value.length == 0) {
                    var defaultFields = this.fields.filter((field) => {
                        return field._visible === true;
                    });
                    //fetch saved value if no value is set
                    var saved = localStorage.getItem(`tableFields.${this.id}`);
                    saved = saved ? JSON.parse(saved) : null;
                    //update default field values
                    this.defaultFields = this.fields.map((field) => {
                        let visible = false;

                        if (saved) {
                            let savedField = saved.find((x) => {
                                if (x.id) {
                                    return x.id == field.id;
                                } else if (x.field) {
                                    return x.field == field.field;
                                } else {
                                    return false;
                                }
                            });
                            if (savedField) {
                                visible = savedField._visible;
                            } else {
                                visible = false;
                            }
                        } else {
                            visible = field._visible;
                        }
                        //handle i18n label, if non existing remove the object to display its given string
                        field.label = this.getLabel(field.i18nLabel);
                        return { ...field, _visible: visible };
                    });

                    if (saved) {
                        saved = saved
                            .map((field) => {
                                //assign correct weight
                                let match = this.fields.find((x) => {
                                    return x.id == field.id;
                                });
                                field.weight = match ? match.weight : 0;
                                return field;
                            })
                            .sort((a, b) => a.weight - b.weight);
                    }

                    this.$emit('input', saved ? saved : defaultFields);
                } else {
                    //value is set
                    this.defaultFields = this.fields.map((field) => {
                        //handle i18n label, if non existing remove the object to display its given string
                        let valueField = this.value.find((x) => {
                            if (x.id) {
                                return x.id == field.id;
                            } else if (x.field) {
                                return x.field == field.field;
                            } else {
                                return false;
                            }
                        });
                        field._visible = valueField ? true : false;
                        field.label = this.getLabel(field.i18nLabel);
                        return field;
                    });
                }
            }
        },
        updateFields() {
            let value = this.defaultFields.filter((field) => {
                return field._visible === true;
            });
            localStorage.setItem(`tableFields.${this.id}`, JSON.stringify(value));
            this.$emit('input', value);
        },
    },
    i18n: {
        messages: {
            en: {
                fields: 'Fields',
                showFields: 'Show Fields',
            },
            fr: {
                fields: 'Données',
                showFields: 'Afficher',
            },
            nl: {
                fields: 'Gegevens',
                showFields: 'Toon',
            },
        },
    },
};
</script>
